<template>
    <header>
        <div class="main flex">
            <div class="logo">
                <img :src="getUrl(system?.system_logo)" alt="" />
            </div>

            <ul class="flex menu">
                <li>
                    <a href="/">首页</a>
                </li>
                <li v-for="item in typeList" :key="item.id">
                    <router-link :to="{ name: 'Type', params: { id: item.id } }">{{ item?.type_name }}</router-link>
                </li>
                <li v-if="system?.system_url">
                    <a :href="system?.system_url" target="_blank">在线商城</a>
                </li>
            </ul>

            <div class="right">
                <router-link v-if="!userInfo" :to="{ name: 'Login' }">登录</router-link>
                <router-link v-if="!userInfo" :to="{ name: 'Register' }" style="margin-left: 15px">注册</router-link>
                <router-link v-if="userInfo" :to="{ name: 'me' }" style="margin-right: 15px">个人中心</router-link>
                <a v-if="userInfo" href="javascript:void(0)" @click="logout">退出登录</a>
                <button @click="$router.push({ name: 'Publish' })">定制发布 <ArrowRight /></button>
            </div>
        </div>
    </header>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ArrowRight } from '@icon-park/vue';
export default {
    name: 'Header',

    data() {
        return {};
    },
    components: {
        ArrowRight,
    },
    computed: {
        ...mapState('system', ['system']),
        ...mapState('types', ['typeList']),
        ...mapState('user', ['userInfo']),
    },
    mounted() {},

    methods: {
        ...mapActions('user', ['logOut']),
        async logout() {
            try {
                const data = await this.logOut();
                if (data.code == 200) {
                    this.$message.success('退出登录成功');
                }
            } catch (error) {
                this.$message.error(error);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.home {
    background-color: transparent !important;
}
header {
    height: 80px;
    // background-color: rgba(0, 0, 0, 0.5);
    background-color: transparent !important;
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 100;

    .main {
        align-items: center;
        position: relative;
        font-family: 'ff';

        .logo {
            width: 200px;
            img {
                width: 100%;
            }
        }
        .menu {
            margin-left: 100px;
            gap: 20px;
            li {
                a {
                    font-size: 16px;
                    color: #fff;
                }
            }
        }
        .right {
            position: absolute;
            right: 0;
            display: flex;
            align-items: center;
            a {
                color: #fff;
                font-size: 16px;
            }
            button {
                height: 40px;
                border: 0;
                outline: 0;
                color: #fff;
                background: #23a6f0;
                border-radius: 5px;
                margin-left: 20px;
                padding: 0 20px;
                display: flex;
                align-items: center;
                animation: down 2s ease-in-out 0s infinite;
                cursor: pointer;
                @keyframes down {
                    0% {
                        transform: translateX(0);
                    }
                    50% {
                        transform: translateX(10px);
                    }
                    100% {
                        transform: translateX(0);
                    }
                }
                .i-icon {
                    display: flex;
                    align-items: center;
                    margin-left: 4px;
                }
            }
        }
    }
}
</style>
